import { jsx as r } from "react/jsx-runtime";
import { Z_INDEX_DATEPICKER as q } from "./index.es191.js";
import { useMemo as s } from "react";
import { v4 as v } from "uuid";
import { DatePickerProvider as w } from "./index.es851.js";
import { DatePickerDropdown as x } from "./index.es852.js";
import { DatePickerCollapsed as z } from "./index.es853.js";
import { DatePickerMenu as _ } from "./index.es854.js";
import { LabeledField as A } from "./index.es512.js";
const Y = ({
  maxDate: f,
  minDate: i = "2017-01-01",
  maxMonth: c,
  startDate: p,
  endDate: e,
  placeholder: o,
  userDatePresets: t,
  fullWidth: j = !1,
  zIndex: F = q,
  maxWidth: I,
  trigger: K,
  align: M = "center",
  side: N = "bottom",
  CTA: d,
  id: P,
  redundantLabelsByPanel: k,
  extraInitialData: l,
  weekStartingDay: u = 0,
  variant: m = "default",
  collapsableLabel: X = "Date Range",
  aria: E,
  onChange: b,
  onValidateSelection: D,
  onClose: R,
  ...Z
}) => {
  const h = s(
    () => ({
      maxDate: f,
      minDate: i,
      maxMonth: c,
      startDate: p,
      endDate: e,
      userDatePresets: t,
      onChange: b,
      placeholder: o,
      id: P || v(),
      redundantLabelsByPanel: k,
      extraInitialData: l,
      weekStartingDay: u,
      variant: m,
      onClose: R
    }),
    [
      f,
      i,
      c,
      p,
      e,
      t,
      b,
      o,
      P,
      k,
      l,
      u,
      m,
      R
    ]
  );
  return /* @__PURE__ */ r(w, { context: h, children: /* @__PURE__ */ r(A, { ...Z, children: m === "default" ? /* @__PURE__ */ r(
    x,
    {
      trigger: K,
      align: M,
      side: N,
      zIndex: F,
      placeholder: o,
      fullWidth: j,
      maxWidth: I,
      ...E,
      children: /* @__PURE__ */ r(_, { CTA: d, onValidateSelection: D })
    }
  ) : /* @__PURE__ */ r(z, { label: X, ...E, children: /* @__PURE__ */ r(_, { CTA: d, onValidateSelection: D }) }) }) });
};
export {
  Y as DatePicker
};
//# sourceMappingURL=index.es50.js.map
